import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SearchReport from '../../../widgets/searchSubProject/SearchReport'
import ProgressiveReportWidget from '../../../widgets/searchSubProject/ProgressiveReportWidget'
import { getProgressiveform } from '../../../redux/actions/subProjectReport'

export default function ProgressiveReport() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    console.log('load ProjectName projectId')

    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProgressiveform()

      if (_schema.form.searchObject.reportDocumentsOption) {
        _schema.form.searchObject.reportDocumentsOption = null

        _schema.form.searchObject.progressiveReport = {
          label: 'รายงาน : ',
          name: 'progressiveReport',
          value: '',
          disabled: false,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณาเลือก โครงการหลัก',
            },
          ],
        }
      }

      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectReport>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <ProgressiveReportWidget schema={schema.form} isEdit={true} />
        </SidebarProposal>
      )}
    </>
  )
}
